import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Buildings, Briefcase, Diamond, ArrowsClockwise, Key, TrendUp } from "@phosphor-icons/react";

const SERVICES = [
  {
    icon: Buildings,
    title: "Residential Advisory",
    desc: "Apartments, penthouses and villas across Ahmedabad's prime corridors.",
    href: "/residential-property-ahmedabad",
  },
  {
    icon: Briefcase,
    title: "Commercial Advisory",
    desc: "Offices, retail and showroom spaces on SG Highway and GIFT City corridor.",
    href: "/commercial-property-ahmedabad",
  },
  {
    icon: Diamond,
    title: "Luxury Property",
    desc: "Private viewings and quiet negotiation on Ahmedabad's finest addresses.",
    href: "/luxury-real-estate-ahmedabad",
  },
  {
    icon: ArrowsClockwise,
    title: "Resale & Selling",
    desc: "Verified, title-checked resale units and genuine price discovery for sellers.",
    href: "/adani-shantigram-resale",
  },
  {
    icon: Key,
    title: "Rental Advisory",
    desc: "Tenants matched with verified owners; landlords listed at market rents.",
    href: "/adani-shantigram-rent",
  },
  {
    icon: TrendUp,
    title: "Investment Guidance",
    desc: "Yield, appreciation and liquidity compared before you commit capital.",
    href: "/real-estate-consultant-ahmedabad",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-forest/70">Our Services</p>
            <h2 className="mt-4 max-w-xl font-serif text-2xl tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              One advisor for every property decision
            </h2>
          </div>
          <p className="max-w-sm text-sm text-slate-500">
            Buying, selling, renting or investing — residential and commercial — handled end to end.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
            >
              <Link
                to={s.href}
                data-testid={`service-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex h-full flex-col rounded-lg border border-black/5 bg-cream p-7 transition-colors duration-200 hover:border-gold"
              >
                <s.icon size={28} weight="duotone" className="text-forest" />
                <h3 className="mt-5 font-serif text-lg text-slate-900">{s.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span className="mt-5 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-forest">
                  Explore
                  <ArrowRight size={13} weight="bold" className="text-gold transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
